import * as Yup from 'yup';

export default Yup.object().shape({
  type: Yup.string(),
});
